import React from 'react';

/**
 * Skip navigation link for keyboard users
 * Allows users to bypass repetitive navigation and jump to main content
 */
function SkipLink({ targetId = 'main-content', children = 'Skip to main content' }) {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-cyan-600 focus:text-white focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-white focus:shadow-lg transition-all"
      aria-label={children}
    >
      {children}
    </a>
  );
}

export default SkipLink;
